import TablesQR from "@/views/admin/qr/TablesQR";

export default {
  path: "tables-qr/list",
  name: "tablesQR",
  component: TablesQR,
  props: true,
  meta: {
    requiresAuth: true
  }
};
